export const primaryDomain = process.env.VUE_APP_API_HOST;
